/**
 * Produces a custom map of one’s imports based on the information contained in webpack’s context
 * module, which webpack’s `require.context()` returns.
 *
 * @param {Function} context A function exported by webpack’s context module, allowing one to
 *   access the information contained in the module.
 * @param {Function} [setKey] An optional, string-replacing function that returns a non-empty
 *   string to serve as a custom key in the map.
 * @returns {object} A map of imported modules, referenced by keys that webpack calls “requests.”
 */
export default function (context, setKey) {
  var map = {};

  if (typeof context !== "function" || typeof context.keys !== "function") {
    var _process, _process$env;
    /* istanbul ignore next */


    ((_process = process) == null ? void 0 : (_process$env = _process.env) == null ? void 0 : _process$env.NODE_ENV) !== "test" && console.error("mapImports(): Your first argument must be a function that’s exported by " + "the context module that webpack’s `require.context()` returns. Visit " + "https://webpack.js.org/guides/dependency-management/ for more information.");
    return map;
  }

  var firstKey = context.keys()[0];

  if (setKey && (typeof setKey !== "function" || typeof setKey(firstKey) !== "string" || setKey(firstKey) === "")) {
    var _process2, _process2$env;
    /* istanbul ignore next */


    ((_process2 = process) == null ? void 0 : (_process2$env = _process2.env) == null ? void 0 : _process2$env.NODE_ENV) !== "test" && console.error("mapImports(): Your second argument must be a function that returns a non-empty string.");
    return map;
  }

  return context.keys().reduce(function (map, key) {
    var _module$default;

    var module = context(key);
    var request = setKey ? setKey(key) : key;
    map[request] = (_module$default = module.default) != null ? _module$default : module;
    return map;
  }, map);
}